angular.module('document')
    .component('documentTypePicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            document: '@',
            required: "<?",
            modelType: "<?",
            activeOnly: "<?",
            onChange: "&"
        },
        templateUrl: "app/document-type/document-type-picker.html",
        controller: function(DocumentType) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.modelType = ctrl.modelType || "object";
                ctrl.required = ctrl.required || false;
                ctrl.activeOnly = ctrl.activeOnly != null? ctrl.activeOnly : true

                DocumentType.query({doc: ctrl.document, activeOnly: ctrl.activeOnly}).$promise.then(items => ctrl.items = itemsFormatAndMap(items))

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue);
            };

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue($item);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange())) {
                    ctrl.onChange()($item);
                }
            };

            function itemsFormatAndMap (items){
                if(!angular.isArray(items)){
                    return []
                }
                return items
                    .map(item => ({id: item.id, name: item.name, color: item.color, active: item.active}))
                //     .sort((a, b) => a.name > b.name ? 1 : -1)
            }
        }
    })
